module.exports = __webpack_public_path__ + "img/91.26d8f19a.jpg";